module.exports = __webpack_public_path__ + "img/Sheba_Hospital.3af9c1fb.svg";